module.exports = __webpack_public_path__ + "static/media/about-img1.d99a47b0.svg";